export default "__VITE_ASSET__iYX4tqUY__"